import * as React from 'react';
import type { SVGProps } from 'react';
const SvgESignPdf24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#F43FE2" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M4.5 13.611c.756-.051 1.435-.17 2.164-.441 1.698-.632 3.51-1.545 4.834-2.944.368-.39.867-1.12.626-1.749-.181-.471-.732-.682-1.152-.638-1.747.183-2.46 2.59-2.269 4.272.293 2.577 3.112 2.826 4.824 1.891 1.26-.687 2.143-2.114 2.892-3.398.052-.089.094-.19.163-.262.022-.023.008.069 0 .101-.098.423-.238.833-.326 1.26-.112.54-.228 1.18.063 1.682.307.528.873.796 1.414.656.66-.17 1.295-.7 1.767-1.235M6.167 17.833c2.103-.499 4.181-.784 6.356-.825 1.528-.03 3.016.008 4.477.44M14.5 7c.25-.345.521-.613.833-.833"
    />
  </svg>
);
export default SvgESignPdf24;
